<div *ngIf="accesstoken" class="frame mx-3">
  <div class="content">
  
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-6 text-center" style="border-right: 1px solid #F0F0F0;">
        <br>
        <div class="newscontainer">
          <img src="../../../../assets/stavar_large.jpg" style="border: 1px solid #ddd;border-radius: 4px;padding: 5px;width:100%;" />
          <div class="d-sm-none" style="height: 95vh;margin-top:26px;">
            <div [innerHTML]="textmobile"></div>
            <br><br>
          </div>
        </div>
      </div>
      <div class="col-md-8 info d-none d-sm-block" style="height: 85vh;margin-top:26px;">
        <div [innerHTML]="text"></div>
        <br><br>
      </div>
    </div>
  </div>
</div>
